import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { noop } from 'lodash';
import { DataSource, generateAllCategory, type Operator } from '../utils';
import * as Types from '../types';

export interface ManagementStoreAtom {
  user: Types.User;
  visible: boolean;
  dataSource: DataSource;
  filterMeta: Types.FilterMeta;
  savedFilters: Types.SavedFilter[];
  drilldownLimit?: number;
  disableCreateFilter?: boolean;
  disabledDataSources?: DataSource[];
  disabledOperators?: Operator[];

  isFilterMetaLoading?: boolean;
  isFilterMetaError?: boolean;

  isSavedFiltersLoading?: boolean;
  isSavedFiltersError?: boolean;

  onClose?: () => void;
  onDataSourceChange?: (dataSource: DataSource) => void;
  onEditFilter?: (id: number, filter: Types.Filter, dataSource: DataSource) => any;
  onEnableFilter?: (id: number, dataSource: DataSource) => any;
  onDeleteFilter?: (filter: Types.SavedFilter, dataSource: DataSource) => any;
  onCloneFilter?: (filter: Types.Filter, dataSource: DataSource) => any;
  onCreateFilter?: (filter: Types.Filter, dataSource: DataSource) => any;
  onFilterMetaRetry?: () => void;
  onSavedFiltersRetry?: () => void;
}

export const filterMeta = atom<ManagementStoreAtom['filterMeta']>({
  dimensions: [],
  categories: {}
});

export const savedFilters = atom<ManagementStoreAtom['savedFilters']>([]);

export const dataSource = atom<ManagementStoreAtom['dataSource']>(DataSource.video);

export const user = atom({} as ManagementStoreAtom['user']);

export const visible = atom<ManagementStoreAtom['visible']>(true);

export const disableCreateFilter = atom<ManagementStoreAtom['disableCreateFilter']>(false);

export const isFilterMetaLoading = atom<ManagementStoreAtom['isFilterMetaLoading']>(false);
export const isFilterMetaError = atom<ManagementStoreAtom['isFilterMetaError']>(false);
export const isSavedFiltersLoading = atom<ManagementStoreAtom['isSavedFiltersLoading']>(false);
export const isSavedFiltersError = atom<ManagementStoreAtom['isSavedFiltersError']>(false);
export const drilldownLimit = atom<ManagementStoreAtom['drilldownLimit']>(900);
export const disabledDataSources = atom<ManagementStoreAtom['disabledDataSources']>([]);
export const disabledOperators = atom<ManagementStoreAtom['disabledOperators']>([]);
export const currentCategory = atom(generateAllCategory());

export const callbacks = atom({
  onDataSourceChange: noop as ManagementStoreAtom['onDataSourceChange'],
  onClose: noop as ManagementStoreAtom['onClose'],
  onEditFilter: noop as ManagementStoreAtom['onEditFilter'],
  onDeleteFilter: noop as ManagementStoreAtom['onDeleteFilter'],
  onEnableFilter: noop as ManagementStoreAtom['onEnableFilter'],
  onCloneFilter: noop as ManagementStoreAtom['onCloneFilter'],
  onCreateFilter: noop as ManagementStoreAtom['onCreateFilter'],
  onFilterMetaRetry: noop as ManagementStoreAtom['onFilterMetaRetry'],
  onSavedFiltersRetry: noop as ManagementStoreAtom['onSavedFiltersRetry'],
});

// Temporary atoms
export const asyncLoadingMask = atom(false);
export const filterEditor = atomWithReset<null | {
  id: number,
  filter: Types.Filter
}>(null);
export const filterClone = atomWithReset<null | {
  id: number,
  filter: Types.Filter
}>(null);
export const filterCreate = atomWithReset(false);